import classNames from 'classnames';

import isMappedTo from './isMappedTo';

const getRelationshipItemDetailClass = (label, interfaceType) => {

	const baseClass = 'RelationshipItemDetail';
	const showRoundedButton = isMappedTo.displayOptions.showRoundedButton(label);
	const showThumbnail = isMappedTo.displayOptions.showThumbnail(label);
	const isOverflow = isMappedTo.group.interfaceType.which(interfaceType) === 'overflow';

	return classNames(baseClass, {
		[`${baseClass}__roundedButton`]: showRoundedButton,
		[`${baseClass}__roundedButton--overflow`]: showRoundedButton && isOverflow,
		[`${baseClass}__thumbnail`]: showThumbnail,
		[`${baseClass}__thumbnail--overflow`]: showThumbnail && isOverflow
	});

};

export default getRelationshipItemDetailClass;
